export const OPTIONS_FREQUENCY = [
	{ label: 'Daily', value: 'date' },
	{ label: 'Weekly (Mondays)', value: 'week' },
	{ label: 'Execute Now', value: 'now' }
]

export const STOCK_STATUS = [
	{ label: 'Stock', value: 'stock' },
	{ label: 'Out of Stock', value: 'out-of-stock' },
	{ label: 'Deslisted', value: 'deslisted' },
	{ label: 'New Listed', value: 'new-listed' },
	{ label: 'Not Launched', value: 'not-launched' },
]